__turbopack_context__.v({
  "guide": "UseAndCareGuideView-module-scss-module__xFqHjW__guide",
  "guide__body": "UseAndCareGuideView-module-scss-module__xFqHjW__guide__body",
  "guide__heading": "UseAndCareGuideView-module-scss-module__xFqHjW__guide__heading",
  "guide__table": "UseAndCareGuideView-module-scss-module__xFqHjW__guide__table",
});
